<ps-ui-modal>
  <ps-ui-modal-body>
    <i class="fa fa-exclamation-circle exclamationStyle" aria-hidden="true"></i>
    <p class="lableText">
      You've uploaded a very high number of zip codes, exceeding the project
      limit of 25,000. For better efficiency and a smoother experience with
      Suppliers, consider targeting broader areas like regions, states, or
      counties instead.
    </p>
    <p class="lableText">
      Reach out to our support team at
      <a href="mailto:support@purespectrum.com">support&#64;purespectrum.com</a>
      if you'd like help refining your approach!
    </p>
  </ps-ui-modal-body>
</ps-ui-modal>
